//HeaderHome.vue



<template>

	<div id="container">

		<div id="container-logo">
			<!-- <img id="bgLogo" :src="'imgs/bollingergrohmann-removebg.svg'" /> -->
			<!-- <img id="buwLogo" :src="'imgs/buw.png'" /> -->
		</div>

		<div>

			<button class="btnNav" id="btnExample">
				<router-link class="router-link-text-home" to="/login">Login</router-link>
			</button>

			<button class="btnNav" id="btnExample">
				<router-link class="router-link-text-home" to="/demo">Demo</router-link>
			</button>

			<button id="btn-change-data" class="btnNav" @click="$emit('changeDataClicked')">
				Data
			</button>

			<!-- <button class="btnNav" id="btnExample">
				<router-link class="router-link-text-home" to="/changedata">Change Data</router-link>
			</button> -->

			<!-- <button class="btnNav" id="btnExample"> 
				<router-link class="router-link-text-home" to="/example">Example</router-link>
			</button>

			<button class="btnNav" id="btnCallApi">
				<router-link class="router-link-text-home" to="/testApi">Test API</router-link>
			</button> -->

			<button class="btnNav" id="btnAbout">
				<router-link class="router-link-text-home" to="/about">About</router-link>
			</button>

			<!-- <button class="btnNav" id="btnAbout">
				<router-link class="router-link-text-home" to="/test">Test</router-link>
			</button> -->

			<button class="btn-logged" id="btn-logged">
				{{ loggedInStatus }}
			</button>

			<!-- <button class="btn-logged" id="btn-admin">
				{{ adminStatus }}
			</button> -->

		</div>

	</div>
	
</template>



<script>

// import HeaderHome from "../components/HeaderHome.vue"


export default {
	emits: [
		'changeDataClicked'
	],
	components: {
		
	},
	data() {
		return {
			msg: "",
			loggedInStatus: '',
			adminStatus: ''
		}
	},
	mounted() {

		if(localStorage.loggedInStatus == '"loggedIn"') {

			this.loggedInStatus ="Logged in";

			if(localStorage.adminStatus == '"admin"') {
				this.loggedInStatus ="Admin";
			}
		}
		else {
			this.loggedInStatus ="Logged out";
		}

		// if(localStorage.adminStatus == '"admin"') {
		// 	this.adminStatus ="Admin";
		// }
		// else {
		// 	this.adminStatus ="NOT Admin";
		// }
	}
}

</script>




<style scoped>

@font-face{
	src: url("/fonts/Roboto-Black.ttf");
	font-family: Roboto;
}

#container {
	display: flex;
	justify-content: space-between; 
	align-items: center;
	height: 60px;
	width: 100vw;
	/* border: 1px solid black; */
}

#container-logo {
	display: flex;
	justify-content: space-between; 
	align-items: center;
	/* height: 60px; */
	/* width: 100vw;  */
}

#projectName {
	font-size: 24px;
	color: gray;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	opacity: .3;
}

#bgLogo {
	height: 100px;
	margin-left: 10px;
	opacity: .8;
}

#buwLogo {
	height: 25px;
	margin-left: 10px;
	display: block;
	opacity: 1;
}

#btnGetStarted {
	border-radius: 25px;
	height: 45px;
	width: 140px;
	margin-right: 20px;
	background: transparent;
	border: solid 1px black;
	color:black;
	cursor: pointer;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	/* box-shadow: 0 0 10px rgba(0, 0, 0, 0.7);   */
}

#btnGetStarted:hover, #btnGetStarted:focus, #btnGetStarted:active{
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	-webkit-transform: scale(1.05);
	transform: scale(1.05);
}

.router-link-text-home {
	text-decoration: none;
	color:black;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-size: .9rem;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.8)
}

.fas {
  font-size: 16px;
  margin-left: 10px;
}

.btnNav{
	position: relative;
	background: transparent;
	border: none;
	font-size: .9rem;
	margin: 0 60px;
	text-decoration: none;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-weight: 400;
	color: rgba(0, 0, 0, 0.8);
	cursor: pointer;
}


.btnNav:after {
	content: "";
	position: absolute;
	background-color: black;
	height: 1px;
	width: 0;
	left: 0;
	bottom: -2px;
	transition: 0.3s;
	transform: scale(0);
	transform-origin: center;
}

.btnNav:hover:after {
	width: 100%;
	transform: scale(1);
}


.btn-logged{
	position: relative;
	background: transparent;
	border: none;
	font-size: 16px;
	margin: 0 40px;
	text-decoration: none;
	color:rgba(0, 0, 0, 0.6);
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 1px;
}

#logged-status {
	position: relative;
	margin: 0 60px;
	font-family: 'Roboto', sans-serif;
}

#btn-change-data {
	font-size: 14px;
}

</style>